import {ProjectManager, User} from '../../generated/sales-terminal-client';

export class AuthUser{
  userId: string;
  email: string;
  profile: User;
  firstName: string;
  lastName: string;
  centreId: number;
  isSuperCentre: boolean;
  isSubCentre: boolean;
  isSalespointUnderSuperCentre: boolean;
  isNewTypeSalespoint: boolean;
  superCentreId: number;
  privileges: string[];
  language: string;
  timezone: string;
  picture: string;
  hasDashboard?: boolean;
  salespointId?: number;
  companyName?: string;
  isPromoter?: boolean;
  centreName?: string;
  salespointName?: string;
  roleName?: string;
  supportsYbo?: boolean;
  isPrivateAccount?: boolean;
  legalPersonId?: number;
  legalPersonCountryCode?: string;
  projectManager?: ProjectManager;
  isLegalBankAccountVerified?: boolean;
}
